import type { DateTime } from "luxon";
import { createContext, useContext } from "react";

// DEFAULT: outside the staffing routes no URL names a week.
export const RouteWeekContext = createContext<DateTime | undefined>(undefined);

/** The first day (Sunday) of the week the staffing page's URL names (`RouteWeekProvider`); undefined when it names none. */
export const useRouteWeekStart = (): DateTime | undefined => useContext(RouteWeekContext);
